/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import { Button, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ClientHoldings } from './ClientHoldings';

import { ReactComponent as Export } from '../../../assets/export-orange-icon.svg';

import ModalExportPortfolio from './ModalExportPortfolio';
import Standings from './Standings';

import './style.scss';

const PortfolioTab = ({
  theme,
  tabs,
  setTabs,
  selectedRowKeys,
  portfolios,
  selectedPortfolio,
}) => {
  const { t } = useTranslation('');
  const totalInit = {
    cash: 0,
    financial: 0,
    cashWaight: 0,
    finWaight: 0,
  };
  
  const { currencyList } = useSelector((state) => state.instrumentsReducer);
  const cashes = useSelector((state) => state.instrumentsReducer?.cashes?.list);

  const [portfolioContent, setPortfolioContent] = useState([]);
  const [portfolioContentCash, setPortfolioContentCash] = useState([]);
  const [totalPortfolio, setTotalPortfolio] = useState(totalInit);
  const [modalExportVisible, setModalExportVisible] = useState(null);

  useEffect(() => {
    if(selectedPortfolio) {
      
        setPortfolioContent([...selectedPortfolio?.portfolio_content ?? [], ...selectedPortfolio?.unlisted_content ?? []]);
        setPortfolioContentCash(selectedPortfolio?.portfolio_cashes);
        setTotalPortfolio({
          totalValue: selectedPortfolio?.total_value,
          totalValueFee: selectedPortfolio?.total_fee,
          cash: selectedPortfolio?.cash_total_value,
          financial: selectedPortfolio?.financial_total_value,
        });

    } else {
      setPortfolioContent([]);
      setPortfolioContentCash([]);
      setTotalPortfolio(totalInit); 
    }
  }, [selectedPortfolio, portfolios]);

  const handleExportSelected = () => {
    setModalExportVisible([selectedRowKeys]);
  };

  const handleExportClose = () => {
    setModalExportVisible(null);
  };

  const handleTabs = (tab) => {
    setTabs(tab);
  };

  return (
    <div style={{ overflowY: 'auto' }}>
      <Row justify={'space-between'} style={{ padding: '24px' }}>
        <Col>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 0 ? 'selected' : ''}`}
            onClick={() => handleTabs(0)}
          >
            {t('STANDINGS')}
          </Button>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 1 ? 'selected' : ''}`}
            onClick={() => handleTabs(1)}
          >
            {t('HOLDINGS')}
          </Button>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 2 ? 'selected' : ''}`}
            onClick={() => handleTabs(2)}
          >
            {t('CASH')}
          </Button>
        </Col>
        <Col style={{ display: 'flex', gap: '8px' }}>
          {/* {selectedPortfolio && (
            <ButtonAdd title="EDIT" height="32px" onClick={handleEdit} />
          )} */}
          <Button
            type="text"
            icon={<Export />}
            iconPosition="end"
            className="client export-btn"
            disabled={!selectedRowKeys}
            onClick={handleExportSelected}
          >
            {t('EXPORT_PORT')}
          </Button>
        </Col>
      </Row>
      {tabs === 0 && (
        <Standings selectedRowKeys={selectedRowKeys} theme={theme} />
      )}
      {tabs !== 0 && (
        <ClientHoldings
          currentPortfolio={
            tabs === 1 ? portfolioContent : portfolioContentCash
          }
          currencyList={currencyList}
          cashes={cashes}
          tabs={tabs}
        />
      )}
      <ModalExportPortfolio
        open={modalExportVisible}
        close={handleExportClose}
        portfolios={portfolios}
      />
    </div>
  );
};

export default PortfolioTab;

PortfolioTab.propTypes = {
  theme: PropTypes.string,
  tabs: PropTypes.number,
  setTabs: PropTypes.func,
  selectedRowKeys: PropTypes.number,
  portfolios: PropTypes.array,
  selectedPortfolio: PropTypes.object,
};
